import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import settingLink from "./setting-link";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { isEmpty, map, size } from "lodash";
import Moment from 'react-moment';
import DeleteModal from "../../components/Common/DeleteModal";
import SettingSidebar from "../../components/VerticalLayout/SettingSidebar";
import { addProjectDocType, getProjectDocType, updateProjectDocType, deleteProjectDocType} from "../../store/settings/Appointment/actions"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    FormGroup,
    Label,
    Input,
    Button,
    Offcanvas,
    OffcanvasHeader,
    OffcanvasBody,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
} from "reactstrap"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import SafeField from "helpers/SafeField";

class ProjectDocumentType extends Component {
    constructor(props) {
        super(props)
        this.state = {
            doctype: ''
        }
        this.handleProDocTypeSubmit = this.handleProDocTypeSubmit.bind(this)
        this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
        this.toggleBackdrop = this.toggleBackdrop.bind(this);
        this.onClickDelete = this.onClickDelete.bind(this);
    }
    toggleBackdrop() {
        this.setState({ isBackdrop: !this.state.isBackdrop });
    }
    toggleDeleteModal = () => {
        this.setState(prevState => ({
            deleteModal: !prevState.deleteModal,
        }));
    };
    onClickDelete = (doctype) => {
        this.setState({ doctype: doctype });
        this.setState({ deleteModal: true });
    };

    handleDeleteProDocType = () => {
        const { onDeleteProDocType } = this.props;
        const { doctype } = this.state;

        if (doctype.id !== undefined) {
            onDeleteProDocType(doctype);
            this.setState({ deleteModal: false });
        }
    };
    toggle() {
        this.setState(prevState => ({
            isRight: !prevState.isRight
        }));
    }
    handleProDocTypeSubmit(value) {
        this.props.addProjectDocType(value, this.props.history);
    }

    componentDidMount() {
        const { onGetProjectDocType } = this.props;
        onGetProjectDocType(localStorage.getItem('userId'));
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { doctypes } = this.props;
        if (!isEmpty(doctypes) && size(prevProps.doctypes) !== size(doctypes)) {
            this.setState({ doctypes: {}, isEdit: false });
        }
    }
    toggleRightCanvas() {
        this.setState({ doctype: "", isEdit: false, isRight: !this.state.isRight });
        this.toggle();
    }
    toggleRightCanvas = arg => {
        const doctype = arg;
        this.setState({
            doctype: {
                id: doctype.id,
                projectDocumentTypeId: doctype.projectDocumentTypeId,
                projectDocumentTypeTitle: doctype.projectDocumentTypeTitle,
                agentId: doctype.agentId
            },
            isEdit: true,
        });
        this.toggle();
    };
    render() {
        const { doctypes, onUpdateProDocType } = this.props;
        const { isEdit, deleteModal } = this.state;
        const doctype = this.state.doctype;
        //
        return (
            <React.Fragment>
                {this.props.loading && this.props.loading ? (
                    <div className="loading">Loading&#8230;</div>
                ) : null}
                <ToastContainer autoClose={2000} />
                <DeleteModal
                    show={deleteModal}
                    onDeleteClick={this.handleDeleteProDocType}
                    onCloseClick={() => this.setState({ deleteModal: false })}
                />
                <div className="page-content">
                    <MetaTags>
                        <title>Agent Profile | Realty Space</title>
                    </MetaTags>
                    <Container fluid>


                        <Row className="mb20">
                            <Col xl="6">
                                <Breadcrumbs
                                    title={this.props.t("Agent")}

                                    breadcrumbItem={this.props.t("Project Document Type")}
                                />

                            </Col>

                        </Row>
                        <Row>
                            <Col xl="3">
                                <SettingSidebar />
                            </Col>

                            <Col xl="9">
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        projectDocumentTypeTitle: (this.state && this.state.projectDocumentTypeTitle) || "",

                                    }}
                                    validationSchema={Yup.object().shape({
                                        projectDocumentTypeTitle: Yup.string().required("This is required"),


                                    })}

                                    onSubmit={this.handleProDocTypeSubmit}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >



                                            <Card>
                                                <CardBody>
                                                    <CardTitle className="mb-4">Project Document Type</CardTitle>
                                                    <Row>


                                                        <Col sm="3">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="projectDocumentTypeTitle">
                                                                    {this.props.t("Title *")}
                                                                </Label>
                                                                <SafeField
                                                                    name="projectDocumentTypeTitle"
                                                                    onChange={handleChange}

                                                                    type="text"

                                                                    className={
                                                                        "form-control" +
                                                                        (errors.projectDocumentTypeTitle && touched.projectDocumentTypeTitle
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }

                                                                    id="projectDocumentTypeTitle"
                                                                />
                                                                <ErrorMessage
                                                                    name="projectDocumentTypeTitle"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>

                                                        </Col>

                                                        <Col sm="2">
                                                            <button type="submit" className="btn btn-primary w-md float-left" style={{ marginTop: 31 }}>Add</button>
                                                        </Col>

                                                    </Row>


                                                </CardBody>
                                            </Card>
                                            <Card>
                                                <CardBody>
                                                    <h5 className="card-title">History</h5>
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered border-primary align-middle table-nowrap mb-0">
                                                            <thead className="">
                                                                <tr>
                                                                    <th>#</th>
                                                                    <th>Title</th>


                                                                    <th>Action</th>


                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {map(doctypes, (doctype, classkey) => (
                                                                    <tr key={"_list_" + classkey}>
                                                                        <th>{classkey + 1}</th>
                                                                        <td>{doctype.projectDocumentTypeTitle}</td>
                                                                        <td>
                                                                        <ActionEdit onClick={() => this.toggleRightCanvas(doctype)} />
                                                                        <ActionDelete onClick={() => this.onClickDelete(doctype)} />
                                                                          
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </CardBody>
                                            </Card>








                                        </Form>
                                    )}
                                </Formik>




                            </Col>

                        </Row>
                        <Offcanvas
                            isOpen={this.state.isRight}
                            direction="end"
                            toggle={this.toggleRightCanvas}
                        >
                            <OffcanvasHeader toggle={this.toggleRightCanvas}>
                                Update
                            </OffcanvasHeader>
                            <OffcanvasBody>
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        id: doctype.id,
                                        projectDocumentTypeId: doctype.projectDocumentTypeId,
                                        projectDocumentTypeTitle: doctype.projectDocumentTypeTitle,
                                        agentId: doctype.agentId

                                    }}
                                    validationSchema={Yup.object().shape({
                                        projectDocumentTypeId: Yup.string().required("This is required"),


                                    })}

                                    onSubmit={values => {

                                        if (isEdit) {
                                            const updateData = {
                                                id: values.id,
                                                projectDocumentTypeId: values.projectDocumentTypeId,
                                                projectDocumentTypeTitle: values.projectDocumentTypeTitle,
                                                agentId: values.agentId
                                            };
                                            onUpdateProDocType(updateData);
                                        } else {

                                        }
                                        this.toggle();
                                    }}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >




                                            <Row>


                                                <Col sm="12">
                                                    <FormGroup className="mb-3">
                                                        <Label htmlFor="projectDocumentTypeTitle">
                                                            {this.props.t("Title *")}
                                                        </Label>
                                                        <SafeField
                                                            name="projectDocumentTypeTitle"
                                                            onChange={handleChange}

                                                            type="text"

                                                            className={
                                                                "form-control" +
                                                                (errors.projectDocumentTypeTitle && touched.projectDocumentTypeTitle
                                                                    ? " is-invalid"
                                                                    : "")
                                                            }

                                                            id="noteTypeTitle"
                                                        />
                                                        <ErrorMessage
                                                            name="projectDocumentTypeTitle"
                                                            component="div"
                                                            className="invalid-feedback"
                                                        />
                                                    </FormGroup>

                                                </Col>

                                                <Col sm="12">
                                                    <button type="submit" className="btn btn-primary w-md float-left">Update</button>
                                                </Col>

                                            </Row>



                                        </Form>
                                    )}
                                </Formik>
                            </OffcanvasBody>
                        </Offcanvas>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}
ProjectDocumentType.propTypes = {
    t: PropTypes.any,
    history: PropTypes.object,
    match: PropTypes.object,
    loading: PropTypes.object,
    addProjectDocType: PropTypes.func,
    onGetProjectDocType: PropTypes.func,
    doctypes: PropTypes.array,
    onDeleteProDocType: PropTypes.func,
    onUpdateProDocType: PropTypes.func


}
const mapStateToProps = ({ AppoinmentObject }) => (
    {

        doctypes: AppoinmentObject.doctypes,
        loading: AppoinmentObject.loading

    })
const mapDispatchToProps = dispatch => ({

    addProjectDocType: (data) => dispatch(addProjectDocType(data)),
    onGetProjectDocType: (agentId) => dispatch(getProjectDocType(agentId)),
    onDeleteProDocType: (id) => dispatch(deleteProjectDocType(id)),
    onUpdateProDocType: (data) => dispatch(updateProjectDocType(data)),

});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ProjectDocumentType))
